<template>
    <section class="container">
        <router-view></router-view>
    </section>
</template>
<style lang="css" src="./packages/iview-theme@3.x/dist/iview.css"></style>
<!--<style lang="css" src="./packages/iview-theme/dist/iview.css"></style>-->
<style lang="scss" src="./assets/sass/admin.scss"></style>
<script>
import { RELEASE_TASKS,RELEASE_ADD_POLLING_TASK,RELEASE_RUN } from "@/stores/modules/release"
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'Admin',
  mounted () {
    Object.values(this[RELEASE_TASKS]).forEach(task=>this[RELEASE_ADD_POLLING_TASK](task))
    // 固定脚本
    this[RELEASE_ADD_POLLING_TASK]({
        id: `refreshCompany`,
        type: "refreshCompany",
        params: {
          simpleTab: 1,
          limit: 9999
        },
        duration: 60*60*1000
    })
    this[RELEASE_ADD_POLLING_TASK]({
        id: `refreshListedCompany`,
        type: "refreshListedCompany",
        params: {
          simpleTab: 1,
          limit: 9999
        },
        duration: 60*60*1000
    })
    this[RELEASE_ADD_POLLING_TASK]({
        id: `refreshCarbonCompany`,
        type: "refreshCarbonCompany",
        params: {
          simpleTab: 1,
          limit: 9999
        },
        duration: 60*60*1000
    })
    this[RELEASE_RUN]()
    if(window.polling){
      window.polling.runTask('refreshCompany')
      window.polling.runTask('refreshListedCompany')
      window.polling.runTask('refreshCarbonCompany')
    }
  },
  methods: {
    ...mapActions([RELEASE_ADD_POLLING_TASK, RELEASE_RUN]),
  },
  computed:{
    ...mapGetters([RELEASE_TASKS])
  }
}
</script>
<style lang="postcss">
.ivu-page-total{
    color:rgb(226, 35, 35);
}
</style>

